import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { nanoid } from '@reduxjs/toolkit';
//import { fetchPosts } from '../actions/postsActions';
//import { Post } from '../components/Post';
import {
    Progress,
    Text,
    ActionIcon,
    createStyles,
    Avatar,
} from '@mantine/core';
import {
    IconBell,
    IconPlus,
    IconMessagePlus
} from '@tabler/icons';

import { useSelector } from 'react-redux';
import { FooterSimple } from '../components/FooterSimple';
import { MsgsHeader } from '../components/MsgsHeader';
import MsgsSearch from '../components/MsgsSearch';
import MsgsItem from '../components/MsgsItem';


import pagani from '../assets/pagani.jpg';



const useStyles = createStyles((theme) => ({
    newMsg: {
        position: 'absolute',
        zIndex: 8,
        backgroundColor: 'dodgerblue',
        //marginTop: 120,
        bottom: 60,
        right: 15,
    },
    newMsgIcon: {
        padding: '5px'
    },
    widthMgmt: {
        margin: '0 auto',
        maxWidth: '800px',
        
    }
    
}));



//this needs params
//needed:scroll area and search
const MsgsPage = () => {
    const { classes } = useStyles();
    return (
        <>
            <MsgsHeader 
                avatar={pagani}
            />
            {/*have a switch case for assignment of the sub menu*/}

            <MsgsSearch className={classes.widthMgmt}/>
            {/*Scroll Area and mapping items and their respective redux values*/}
            <br/>
            <MsgsItem  className={classes.widthMgmt}/>
            <br/>
            <MsgsItem/>
            <br/>
            <MsgsItem/>
            <br/>
            <MsgsItem/>
            <br/>
            <MsgsItem/>
            <br/>
            <ActionIcon color="dodgeblue" radius="xl" size={48} className={classes.newMsg}>
                <IconMessagePlus color="white" size="5rem" className={classes.newMsgIcon}/>
            </ActionIcon>
            <FooterSimple />
        </>
    )

}

export default MsgsPage
